<template>

    <div class="ribbon">{{ label }}</div>

</template>

<style scoped lang="scss">

    .ribbon {
        @include font-bold(8px);
        background: $color-primary;
        color: #fff;
        left: -60px;
        letter-spacing: 1px;
        line-height: 30px;
        position: absolute;
        text-align: center;
        text-transform: uppercase;
        top: 25px;
        transform: rotate(-45deg);
        user-select: none;
        width: 200px;
        z-index: 1;
    }

</style>

<script>

export default {

    props: {
        label: {
            type: String,
            required: true,
        },
    },

}

</script>
